import { render } from "./WhoWeare.vue?vue&type=template&id=1797ccb8&scoped=true"
import script from "./WhoWeare.vue?vue&type=script&lang=js"
export * from "./WhoWeare.vue?vue&type=script&lang=js"

import "./WhoWeare.vue?vue&type=style&index=0&id=1797ccb8&scoped=true&lang=css"
import "./WhoWeare.vue?vue&type=style&index=1&id=1797ccb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1797ccb8"]])

export default __exports__